import { EventEmitter } from "events";

export enum EventType {
  Rephrase = 'rephrase',
  Refine = 'refine',
  CloseInsertTable = 'closeInsertTable'
}
const eventBus = new EventEmitter();

export default eventBus;